import styles from './TransactionHistory.module.scss';
import { GreenButton } from '../../../Shared/GreenButton/GreenButton';
import { useGetTransactions } from '../../../../hooks/useGetTransactions';
import { useState } from 'react';
import { CURRENCY } from '../../../../constants';
import { useGetWithdrawRequestsGroupByDate } from '../../../../hooks/useGetWithdrawRequestsGroupByDate';
import { Badge } from '../../../Shared/Badge/Badge';

interface ITransactionHistoryProps {
    userId: string;
}

enum ETabs {
    TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
    ORDERS = 'ORDERS',
}

export const TransactionHistory = ({ userId }: ITransactionHistoryProps) => {
    const pageSize = 10;
    const [pageNumber, setPageNumber] = useState(1);
    const [pageNumberOrder, setPageNumberOrder] = useState(1);

    const [activeTab, setActiveTab] = useState<ETabs>(ETabs.TRANSACTION_HISTORY);
    const { transactions, isLoading: isLoadingTransactions } = useGetTransactions({
        userId,
        pageNumber,
        pageSize,
    });

    const { withdrawRequests, isLoading: isLoadingWithdrawRequests } = useGetWithdrawRequestsGroupByDate({
        pageNumber: pageNumberOrder,
        pageSize,
        userId,
    });

    const loadMore = () => {
        if (activeTab === ETabs.TRANSACTION_HISTORY) {
            setPageNumber(pageNumber + 1);
        } else {
            setPageNumberOrder(pageNumberOrder + 1);
        }
    };

    const isLoading = isLoadingWithdrawRequests && isLoadingTransactions;

    if (isLoading) {
        return <div className={styles.container}></div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                <div
                    className={
                        activeTab === ETabs.TRANSACTION_HISTORY ? [styles.tab, styles.active].join(' ') : styles.tab
                    }
                    onClick={() => {
                        setActiveTab(ETabs.TRANSACTION_HISTORY);
                    }}
                >
                    Transaction History
                </div>
                <div
                    className={activeTab === ETabs.ORDERS ? [styles.tab, styles.active].join(' ') : styles.tab}
                    onClick={() => {
                        setActiveTab(ETabs.ORDERS);
                    }}
                >
                    Orders
                </div>
            </div>
            {activeTab === ETabs.TRANSACTION_HISTORY &&
                transactions.map((transaction) => (
                    <div id={transaction.date} key={transaction.date}>
                        <div className={styles.date}>{transaction.date}</div>
                        <div className={styles.transactionBlock}>
                            {transaction?.values &&
                                transaction?.values.map((tr) => (
                                    <div className={styles.row} key={tr.id}>
                                        <div className={styles.column}>
                                            <div className={styles.name}>{tr.description}</div>
                                            <div className={styles.time}>{tr.time}</div>
                                        </div>
                                        <div
                                            className={
                                                tr.amount > 0
                                                    ? styles.balance
                                                    : [styles.balance, styles.minus].join(' ')
                                            }
                                        >
                                            {tr.amount > 0 && '+'}
                                            {tr.amount}
                                            {CURRENCY}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}

            {activeTab === ETabs.ORDERS &&
                withdrawRequests.map((withdrawRequest) => (
                    <div key={withdrawRequest.date}>
                        <div className={styles.date}>{withdrawRequest.date}</div>
                        <div className={styles.transactionBlock}>
                            {withdrawRequest?.values &&
                                withdrawRequest?.values.map((tr) => (
                                    <div className={styles.row} key={tr.id}>
                                        <div className={styles.line}>
                                            <div className={styles.lineColumn}>
                                                <div className={styles.name}>WITHDRAW</div>
                                                <div className={styles.time}>{tr.createdAt}</div>
                                            </div>
                                            <div className={styles.status}>
                                                <Badge status={tr.status} />
                                            </div>
                                        </div>

                                        <div className={[styles.balance, styles.minus].join(' ')}>
                                            -{tr.amount}
                                            {CURRENCY}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}

            <div className={styles.marginTop}>
                <GreenButton outline noMargin onClick={loadMore}>
                    See more
                </GreenButton>
            </div>
        </div>
    );
};
